import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/common/Table/CustomTable";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { initFilterInput, renderColumns } from "./constants";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import { convertBankList } from "./helpers/convertBankList";
import TextInput from "../../../components/common/TextInput/TextInput";
import { IoStorefront } from "react-icons/io5";
import { Button, Modal } from "antd";
import TextInfo from "../../../components/common/TextInfo/TextInfo";
import IsEmpty from "../../../components/helpers/IsEmpty";
import Swal from "sweetalert2";

export default function BankList() {
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dataBanks, setDataBanks] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [modalAdd, setModalAdd] = useState(false);
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selected, setSelected] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedId, setSelectedId] = useState();

  useEffect(() => {
    getData();
  }, [filterInput]);

  const getData = () => {
    setLoading(true);
    const data = {
      search: filterInput.searchName,
      page: filterInput.page,
      page_size: filterInput.pageSize,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}bank/pagination`;
    httpclient
      .GET(url, data)
      .then((res) => {
        setDataBanks(convertBankList(res.data.data.items, handleOpenPreview));
        setTablePagination({
          current: res.data.data.page,
          pageSize: res.data.data.per_page,
          total: res.data.data.total_item,
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      });
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleUpdate = (record) => {
    setSelected(record);
    setModalAdd(true);
    setSelectedId(record.id);
  };
  const handleDelete = (record) => {
    let url = `${process.env.REACT_APP_BASE_API_URL}bank/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: `Apakah anda yakin ingin menghapus rekening ${record.accountName}, dengan nomor ${record.accountNumber} bank ${record.bankName}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          });
      }
    });
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  const handleFilter = (e) => {
    const { value, name } = e.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        pageSize: value,
      }));
    }
    if (name === "name") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        setFilterInput((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    };

  const CloseModal = () => {
    setSelected({
      accountName: "",
      accountNumber: "",
      bankName: "",
    });
    setErrors({});
    setModalAdd(false);
    setSelectedId();
  };

  const handleTextInput = (event) => {
    const { name, value } = event.target;

    setSelected((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let data = {
        bank_name: selected.bankName,
        account_name: selected.accountName,
        account_number: selected.accountNumber,
      };
      console.log(data);
      setSubmitting(true);
      if (selectedId) {
        let url = `${process.env.REACT_APP_BASE_API_URL}bank/${selectedId}`;
        httpclient
          .PUT(url, data)
          .then((res) => {
            getData();
            setModalAdd(false);
            SwalToast.fire({
              icon: "success",
              title: res.data.message,
            });
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        let url = `${process.env.REACT_APP_BASE_API_URL}bank`;
        httpclient
          .POST(url, data)
          .then((res) => {
            getData();
            setModalAdd(false);
            SwalToast.fire({
              icon: "success",
              title: res.data.message,
            });
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  const validate = () => {
    const newErrors = {};
    if (IsEmpty(selected.accountName)) {
      newErrors.accountName = "Nama Rekening tidak boleh kosong";
    }
    if (IsEmpty(selected.accountNumber)) {
      newErrors.accountNumber = "Nomor Rekening tidak boleh kosong";
    }
    if (IsEmpty(selected.bankName)) {
      newErrors.bankName = "Nama bank tidak boleh kosong";
    }
    return newErrors;
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex"
            style={{ fontSize: "13px", justifyContent: "space-between" }}
          >
            <div>
              <Title text={"Bank Account"} />
              <Breadcrumb current={"Bank Account"} />
            </div>
            <div>
              <div
                style={{
                  padding: 10,
                  border: "1px solid #DCDCDC",
                  borderRadius: 5,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div style={{ fontSize: 18, color: "#303030" }}>
                  <IoStorefront className="total-icon" />
                  <span style={{ fontWeight: 700, marginLeft: 5 }}>
                    {tablePagination.total || 0}
                  </span>{" "}
                  Rekening
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex py-3 px-0">
            <div className="d-flex col-6 px-0">
              <TextInput
                id="pageSize"
                label="Tampilkan"
                handleEnter={handleEnter}
                handleChange={handleFilter}
                width={68}
                value={filterInput.pageSize}
              />
              <div className="col-6">
                <TextInput
                  label="Nama Rekening/Nama Bank"
                  id="searchName"
                  handleEnter={handleEnter}
                  handleChange={handleFilter}
                  value={filterInput.search}
                  width={"100%"}
                />
              </div>
            </div>

            <CanAccess
              role={AuthorizationList.create_bank}
              yes={
                <div
                  className="ml-auto align-self-end mb-3"
                  onClick={() => {
                    setSelectedId();
                    setModalAdd(true);
                  }}
                >
                  <Button
                    style={{
                      alignSelf: "flex-end",
                      height: 36,
                      background: "#2C465C",
                      color: "#FFF",
                      width: 180,
                      borderRadius: 6,
                    }}
                  >
                    + Tambah Rekening
                  </Button>
                </div>
              }
            />
          </div>

          <div className="mt-2">
            <CustomTable
              columns={renderColumns(handleUpdate, handleDelete)}
              data={dataBanks}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
        <Modal
          centered
          title={selectedId ? "Ubah Rekening" : "Tambah Rekening"}
          visible={modalAdd}
          onCancel={CloseModal}
          footer={[
            <Button
              onClick={CloseModal}
              style={{
                border: "0.75px solid #DCDCDC",
                borderRadius: 6,
                width: 120,
                height: 36,
                color: "#000",
                background: "#FFFFFF",
              }}
            >
              Kembali
            </Button>,
            <Button
              disabled={submitting}
              key="submit"
              type="primary"
              onClick={onSubmit}
              className="btn-modal"
              style={{ width: 120 }}
            >
              {selectedId ? "Ubah" : "Tambah"}
            </Button>,
          ]}
        >
          <div className="modal-form-content mt-4">
            <TextInfo
              title="No. Rekening"
              value={selected?.accountNumber}
              type={"input"}
              id={"accountNumber"}
              handleChange={handleTextInput}
              error={errors?.accountNumber}
              isForm
            />
            <TextInfo
              title="Nama Rekening"
              value={selected?.accountName}
              type={"input"}
              id={"accountName"}
              handleChange={handleTextInput}
              error={errors?.accountName}
              isForm
            />
            <TextInfo
              title="Nama Bank"
              value={selected?.bankName}
              type={"input"}
              id={"bankName"}
              handleChange={handleTextInput}
              error={errors?.bankName}
              isForm
            />
          </div>
        </Modal>
      </div>
    </>
  );
}
